import { haptic } from '@/lib/telegram';
import clsx from 'clsx';
import styles from './DurationPicker.module.css';

interface Props {
  value: number; // минуты
  onChange: (minutes: number) => void;
}

const OPTIONS = [
  { minutes: 12 * 60, label: '12 часов' },
  { minutes: 24 * 60, label: '1 день' },
  { minutes: 72 * 60, label: '3 дня' },
];

export const DurationPicker = ({ value, onChange }: Props) => (
  <div className={styles.row}>
    {OPTIONS.map((opt) => {
      const isActive = opt.minutes === value;
      return (
        <button
          key={opt.minutes}
          type="button"
          onClick={() => { haptic.selection(); onChange(opt.minutes); }}
          className={clsx(styles.btn, isActive && styles.btnActive)}
        >
          {opt.label}
        </button>
      );
    })}
  </div>
);